import React, { useEffect, useState } from "react";
import { FiGlobe, FiPackage, FiTruck } from "react-icons/fi";

import logo from "../../assets/Thamizhi_logo.png";

export default function PageLoader() {
  const [loading, setLoading] = useState(() => {
    if (typeof window === "undefined") {
      return true;
    }

    return !window.sessionStorage.getItem("tiv-loader-seen");
  });

  useEffect(() => {
    if (!loading) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      window.sessionStorage.setItem("tiv-loader-seen", "true");
      setLoading(false);
    }, 1600);

    return () => window.clearTimeout(timer);
  }, [loading]);

  if (!loading) {
    return null;
  }

  return (
    <div className="page-loader" role="status" aria-live="polite" aria-label="Loading website">
      <div className="page-loader__panel">
        <div className="page-loader__brand">
          <img src={logo} alt="Thamizhi International Ventures" className="page-loader__logo" />
          <div>
            <p className="section-kicker">Thamizhi International Ventures</p>
            <h1>Initializing global sourcing network</h1>
          </div>
        </div>

        <div className="page-loader__icons" aria-hidden="true">
          <FiPackage />
          <FiTruck />
          <FiGlobe />
        </div>

        <div className="page-loader__bar">
          <span />
        </div>
      </div>
    </div>
  );
}
